import { HotkeyPlugin, onKeyDownToggleElement } from '@udecode/plate-common';

import { createMyPluginFactory } from '../plateFunctions';
import {
  ELEMENT_HEADING_LARGE,
  ELEMENT_HEADING_MEDIUM,
  ELEMENT_HEADING_SMALL,
} from '../plateTypes';

export type HeadingPlugin = HotkeyPlugin;

export const createHeadingLargePlugin = createMyPluginFactory({
  key: ELEMENT_HEADING_LARGE,
  isElement: true,
  deserializeHtml: {
    getNode(el, node) {
      const id = el.getAttribute('id');
      return {
        ...node,
        type: ELEMENT_HEADING_LARGE,
        id,
      };
    },
    rules: [
      {
        validNodeName: ['H1', 'H2'],
      },
    ],
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: ['mod+opt+1', 'mod+shift+1'],
  },
});

export const createHeadingMediumPlugin = createMyPluginFactory({
  key: ELEMENT_HEADING_MEDIUM,
  isElement: true,
  deserializeHtml: {
    rules: [{ validNodeName: 'H3' }],
    getNode(el, node) {
      const id = el.getAttribute('id');
      return {
        ...node,
        type: ELEMENT_HEADING_MEDIUM,
        id,
      };
    },
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: ['mod+opt+2', 'mod+shift+2'],
  },
});

export const createHeadingSmallPlugin = createMyPluginFactory({
  key: ELEMENT_HEADING_SMALL,
  isElement: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: ['H4', 'H5', 'H6'],
      },
    ],
    getNode(el, node) {
      const id = el.getAttribute('id');
      return {
        ...node,
        type: ELEMENT_HEADING_SMALL,
        id,
      };
    },
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement,
  },
  options: {
    hotkey: ['mod+opt+3', 'mod+shift+3'],
  },
});
